<template>
  <div class="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 relative text-white font-sans">
    <div class="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-romance-red/10 blur-[120px] rounded-full"></div>

    <div class="max-w-md w-full z-10">
      <div class="text-center mb-10">
        <img src="@/assets/logo_red_2.png" class="mx-auto h-24 w-auto mb-4">
        <h2 class="text-3xl font-black uppercase italic tracking-tighter">Nueva Contraseña</h2>
        <p class="text-gray-500 mt-2 text-sm italic">Elegí una llave que no se te olvide.</p>
      </div>

      <form @submit.prevent="handleReset" class="space-y-6">
        <div class="relative">
          <label class="block text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2 ml-2">Nueva Contraseña</label>
          <div class="relative">
            <input
              v-model="newPassword"
              :type="showPass ? 'text' : 'password'"
              placeholder="••••••••" required
              class="w-full p-4 pr-12 bg-white/5 border border-white/10 rounded-2xl focus:ring-2 focus:ring-romance-red outline-none transition-all"
            >
            <button
              type="button"
              @click="showPass = !showPass"
              class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white transition-colors"
            >
              <span v-if="showPass">🙈</span>
              <span v-else>👁️</span>
            </button>
          </div>
        </div>

        <div class="relative">
          <label class="block text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2 ml-2">Confirmar Contraseña</label>
          <div class="relative">
            <input
              v-model="confirmPassword"
              :type="showConfirmPass ? 'text' : 'password'"
              placeholder="••••••••" required
              class="w-full p-4 pr-12 bg-white/5 border border-white/10 rounded-2xl focus:ring-2 focus:ring-romance-red outline-none transition-all"
            >
            <button
              type="button"
              @click="showConfirmPass = !showConfirmPass"
              class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white transition-colors"
            >
              <span v-if="showConfirmPass">🙈</span>
              <span v-else>👁️</span>
            </button>
          </div>
        </div>

        <button type="submit" :disabled="loading"
                class="w-full py-5 bg-gradient-to-r from-romance-red to-blue-500 text-white font-black rounded-2xl shadow-xl hover:opacity-90 transition-all uppercase tracking-widest active:scale-95">
          {{ loading ? 'Actualizando...' : 'Actualizar Llave' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/api'
import Swal from 'sweetalert2'

const route = useRoute()
const router = useRouter()

const newPassword = ref('')
const confirmPassword = ref('')
const loading = ref(false)

// Estados para mostrar/ocultar contraseña
const showPass = ref(false)
const showConfirmPass = ref(false)

const handleReset = async () => {
  if (newPassword.value !== confirmPassword.value) {
    Swal.fire({
      icon: 'warning',
      title: 'No coinciden',
      text: 'Las contraseñas deben ser iguales.',
      confirmButtonColor: '#ec4899',
      customClass: { popup: 'rounded-[2rem]' }
    })
    return
  }

  loading.value = true
  try {
    await api.post('/password/reset', {
      token: route.query.token,
      email: route.query.email,
      new_password: newPassword.value
    })

    Swal.fire({
      icon: 'success',
      title: '¡Contraseña actualizada!',
      text: 'Ya podés iniciar sesión con tu nueva llave.',
      confirmButtonColor: '#ec4899',
      customClass: { popup: 'rounded-[2rem]' }
    }).then(() => router.push('/signin'))

  } catch (err) {
    Swal.fire({
      icon: 'error',
      title: 'Enlace inválido',
      text: err.response?.data?.error || 'El token expiró o ya fue utilizado.',
      confirmButtonColor: '#ef4444',
      customClass: { popup: 'rounded-[2rem]' }
    })
  } finally {
    loading.value = false
  }
}
</script>